import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

export const useCriteriaStorePredicateUuidsWithoutParent = () => {
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const predicates = useStore(store, (s) => s.predicates);

    return Object.entries(predicates).reduce((acc, [key, predicate]) => {
        return predicate?.predicateType &&
            ['Predicate', 'PredicateGroup'].includes(predicate?.predicateType) &&
            typeof predicate?.parentPredicateId !== 'undefined'
            ? [...acc, key]
            : acc;
    }, []);
};
